import { RootState } from '../store';

export const authSelector = (state: RootState) => state.authentication;
